import { FeatureSubscriptionInfoEnums } from './../../../../../modules/shared/enums/feature-subscription-info.enum';
import { SubscriptionFeatureLimitM } from './../../../../../modules/shared/models/organization-subscription/subscription-feature-limit.modal';
import { OrganizationSubscriptionService } from './../../../../../modules/shared/services/organization-subscription.service';
import { StageDisplayOrderUpdate } from './../crm-shared-configuration/models/stage-displayorder-update.model';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { TitleCasePipe, DatePipe } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil, mergeMap } from 'rxjs/operators';

// Models
import { Channel } from '../crm-shared-configuration/models/channel.model';
import { Stage } from '../crm-shared-configuration/models/stage.model';

// Services
import { AppMainService } from 'src/app/app-main.service';
import { CrmSharedConfigurationService } from '../crm-shared-configuration/services/crm-shared-configuration.service';
import { ConfirmationService } from 'primeng/api';
import { TranslocoService } from '@ngneat/transloco';

// Constants
import { Answer, Messages, Severity } from 'src/app/configurations/crm/constants/constants';
import { LeadModuleId, OpportunityModuleId } from 'src/app/modules/shared/constants/modules.constant';
import { CrmOpportunityService } from '../../../opportunity/opportunity.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { UserService } from 'src/app/service/userservice';
import { ConfigurationService } from 'src/app/configurations/configurationService';
import { CrmSettingsService } from 'src/app/modules/shared/services/crm-settings.service';
import { CrmSettingModel } from 'src/app/configurations/models/organization-settings.model';

@Component({
    selector: 'app-crm-shared-channel',
    templateUrl: './crm-shared-channel.component.html',
    styleUrls: ['./crm-shared-channel.component.scss'],
    providers: [ConfirmationService, DatePipe]
})
export class CrmSharedChannelComponent implements OnInit, OnChanges {
    @Input() moduleId: number;
    @Input() addNewElement: { name: string };

    @Output() cancelChannelAddUpdateModal = new EventEmitter();

    action: string;
    answertypeConstants = Answer;
    defaultColor: string = '#FFFF00';
    channelTranslate = {
        AddChannelHeader: "",
        EditChannelHeader: "",
        DeleteConfirmationHeader: "",
        ChannelDeleteConfirmationMsg: ""
    };

    globalChannelId: number;
    channels: Channel[] = [];
    channelForm: FormGroup;
    noDataChannel: string = 'Loading Channels...';
    displayCreateUpdateChannel: boolean = false;
    statusDisabled: boolean = false;
    isEnabledParentChildTemplate:boolean = false;

    stages: Stage[] = [];
    channelStageForm: FormGroup;
    displayCreateUpdateStage: boolean = false;
    createUpdateStageHeader: string = '';
    channelHeader: string = '';
    dragChannel = null;
    dragStage: Stage = null;
    isDraggable: boolean = false;
    leadModuleId = LeadModuleId;

    forcastCategories: Array<any> = [];
    isStageEdit: boolean = false;
    oppModuleId: number = OpportunityModuleId;
    forcastCategoryEditList: Array<any> = [];
    /* Subject to unsubscribe */
    private ngUnsubscribe = new Subject<void>();
    ownerList:any[] = [];
    leadOwnerSettings: any = {};

    subscriptionLimit: SubscriptionFeatureLimitM = null;

    constructor(
        private fb: FormBuilder,
        private appMainService: AppMainService,
        private configService: CrmSharedConfigurationService,
        private confirmationService: ConfirmationService,
        private translocoService: TranslocoService,
        private titleCasePipe: TitleCasePipe,
        private opportunityService: CrmOpportunityService,
        public app: AppMainComponent,
        public userService: UserService,
        private crmSettingsService: CrmSettingsService,
        private organizationSubscriptionService: OrganizationSubscriptionService
    ) { }

    ngOnInit(): void {
        this.displayCreateUpdateChannel = false;
        this.getTranslatedValue();
        this.prepareChannelForm();
        this.prepareChannelStageForm();
        this.getChannels();
        this.getUserList();
        this.getSettingsData();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.addNewElement.currentValue) {
            const channelData: Partial<Channel> = {
                name: '',
                moduleId: this.moduleId,
                isActive: false
            };
            this.checkSubscriptionLimit();
            this.showCreateUpdateChannelModal('create', channelData);
        }
        if (changes.moduleId && changes.moduleId.currentValue){
            if (changes.moduleId.currentValue === OpportunityModuleId){
                this.getForecastCategory();
            }
        }
    }

    checkSubscriptionLimit(){
        this.organizationSubscriptionService
        .getFeatureSubscriptionInfo(FeatureSubscriptionInfoEnums.Channel,this.moduleId).subscribe({
            next: (response)=>{
                this.subscriptionLimit = response;
            }
        })
    }

    get subscriptionLimitReached(){
        return (this.action=='create'
        && this.subscriptionLimit?.allowedLicence
        && this.subscriptionLimit?.allowedLicence<=this.subscriptionLimit?.consumedLicense)
    }

    getTranslatedValue(): void {
        this.translocoService.selectTranslate('Configuration.CRM.Add_Channel_Stage').subscribe((data) => {
            this.channelTranslate.AddChannelHeader = data;
        });

        this.translocoService.selectTranslate('Configuration.CRM.Edit_Stage').subscribe((data) => {
            this.channelTranslate.EditChannelHeader = data;
        });

        this.translocoService.selectTranslate('Configuration.CRM.Delete_Confirmation').subscribe((data) => {
            this.channelTranslate.DeleteConfirmationHeader = data;
        });

        this.translocoService.selectTranslate('Configuration.CRM.Channel_Delete_Confirmation_MSG').subscribe((data) => {
            this.channelTranslate.ChannelDeleteConfirmationMsg = data;
        });
    }

    // Channel Operations
    prepareChannelForm(): void {
        this.channelForm = this.fb.group({
            id: [null],
            moduleId: [this.moduleId],
            name: [null, [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
            isActive: [false],
        });
    }

    getChannels(shouldSetStages: boolean = false): void {
        this.noDataChannel = 'Loading Channels...';

        this.configService.getChannels(this.moduleId)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((channels: Channel[]) => {
                this.channels = channels || [];
                this.noDataChannel = this.channels.length ? '' : 'No channel found.';

                if (shouldSetStages && this.globalChannelId !== -1) {
                    this.setStagesAfterUpdate(this.globalChannelId);
                }
            }, () => {
                this.noDataChannel = 'No channel found.';
            });
    }

    createChannel(channelData: Channel): void {
        const hasDuplicateChannel: boolean = this.checkDuplicateChannel(channelData);

        if (hasDuplicateChannel) {
            this.configService.openToast(Severity.Error, Messages.Channel_Already_Exists);
            return;
        }

        const payload: Partial<Channel> = {
            moduleId: channelData.moduleId,
            name: channelData.name,
            isActive: channelData.isActive
        };

        this.appMainService.isShowSpinner('createChannel');

        this.configService.createChannel(payload)
            .pipe(takeUntil(this.ngUnsubscribe), mergeMap(async () => this.getChannels(true)))
            .subscribe(() => {
                this.displayCreateUpdateChannel = false;
                this.configService.openToast(Severity.Success, Messages.Channel_Created_Success);
                this.appMainService.isHideSpinner('createChannel');
            }, (err) => {
                this.displayCreateUpdateChannel = false;
                const message: string = this.configService.getErrorMessage(err, 'CHANNEL_CREATE');
                this.configService.openToast(Severity.Error, message);
                this.appMainService.isHideSpinner('createChannel');
            });
    }

    updateChannel(channelData: Channel): void {
        const hasDuplicateChannel: boolean = this.checkDuplicateChannel(channelData);

        if (hasDuplicateChannel) {
            this.configService.openToast(Severity.Error, Messages.Channel_Already_Exists);
            return;
        }

        this.appMainService.isShowSpinner('updateChannel');

        this.configService.updateChannel(channelData)
            .pipe(takeUntil(this.ngUnsubscribe), mergeMap(async () => this.getChannels(true)))
            .subscribe(() => {
                this.displayCreateUpdateChannel = false;
                this.configService.openToast(Severity.Success, Messages.Channel_Updated_Success);
                this.appMainService.isHideSpinner('updateChannel');
            }, (err) => {
                this.displayCreateUpdateChannel = false;
                const message: string = this.configService.getErrorMessage(err, 'CHANNEL_UPDATE');
                this.configService.openToast(Severity.Error, message);
                this.appMainService.isHideSpinner('updateChannel');
            });
    }

    setDefaultChannel(channel: Channel): void {
        this.appMainService.isShowSpinner('setDefaultChannel');

        this.configService.setDefaultChannel(this.moduleId, channel.id)
            .pipe(takeUntil(this.ngUnsubscribe), mergeMap(async () => this.getChannels(true)))
            .subscribe(() => {
                this.configService.openToast(Severity.Success, `${channel.name} ${Messages.Set_Default_Channel_Success}`);
                this.appMainService.isHideSpinner('setDefaultChannel');
            }, (err) => {
                const message: string = this.configService.getErrorMessage(err, 'SET_DEFAULT_CHANNEL');
                this.configService.openToast(Severity.Error, message);
                this.appMainService.isHideSpinner('setDefaultChannel');
            });
    }

    deleteChannel(channelId: number) {
        this.confirmationService.confirm({
            message: this.channelTranslate.ChannelDeleteConfirmationMsg,
            header: this.channelTranslate.DeleteConfirmationHeader,
            icon: 'pi pi-info-circle',
            accept: () => {
                if (this.globalChannelId === channelId) {
                    this.globalChannelId = -1;
                }

                this.appMainService.isShowSpinner('deleteChannel');

                this.configService.deleteChannel(this.moduleId, channelId)
                    .pipe(takeUntil(this.ngUnsubscribe), mergeMap(async () => this.getChannels(true)))
                    .subscribe(() => {
                        this.configService.openToast(Severity.Success, Messages.Channel_Deleted_Success);
                        this.appMainService.isHideSpinner('deleteChannel');
                    }, (err) => {
                        const message: string = this.configService.getErrorMessage(err, 'CHANNEL_DELETE');
                        this.configService.openToast(Severity.Error, message);
                        this.appMainService.isHideSpinner('deleteChannel');
                    });
            }
        });
    }

    checkDuplicateChannel(channelData: Channel): boolean {
        const channelWithDuplicateName = this.channels?.find(channel => (channel.id !== channelData?.id) && (channel.name?.toLowerCase()
            === channelData?.name?.toLowerCase()));
        return !!channelWithDuplicateName;
    }

    createUpdateChannel(channelData: Channel): void {
        this.action === 'create' ? this.createChannel(channelData) : this.updateChannel(channelData);
    }

    showCreateUpdateChannelModal(action: string, channelData: Partial<Channel>): void {
        this.action = action;
        this.channelHeader = this.titleCasePipe.transform(action) + ' Channel';
        this.displayCreateUpdateChannel = true;
        this.statusDisabled = channelData.isDefault;
        channelData.moduleId = this.moduleId;
        this.channelForm?.patchValue(channelData);
    }

    setStagesAfterUpdate(channelId: number): void {
        const index: number = this.channels.findIndex(channel => channel.id === channelId);

        if (index > -1) {
            this.channels[index].stageList = this.stages;
        }
    }

    // Stage Operations
    prepareChannelStageForm(): void {
        this.channelStageForm = this.fb.group({
            id: [null],
            channelId: [null],
            isActive: [true],
            name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
            color: [''],
            moduleId: [null],
            probability: [null],
            forcastCategory: [0],
            note: [''],
            ownerId: [null],
        });
    }

    getChannelStages(isExpanded: boolean, channelId: number): void {
        if (isExpanded) {
            const index: number = this.channels?.findIndex(channel => channel.id === channelId);
            this.channels[index].stageList = [];
            this.globalChannelId = channelId;

            this.configService.getChannelStages(this.moduleId, channelId)
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(stages => {
                    this.stages = stages || [];
                    this.channels[index].stageList = this.stages;
                    this.channels[index].numberOfStages = this.stages.length;
                });
        }
    }

    createStage(stageData: Stage): void {
        const hasDuplicateStage: boolean = this.checkDuplicateStage(stageData);

        if (hasDuplicateStage) {
            this.configService.openToast(Severity.Error, Messages.Stage_Already_Exists);
            return;
        }

        this.appMainService.isShowSpinner('createStage');

        this.configService.createStage(stageData)
            .pipe(takeUntil(this.ngUnsubscribe), mergeMap(async () => this.getChannelStages(true, stageData.channelId)))
            .subscribe(() => {
                this.displayCreateUpdateStage = false;
                this.configService.openToast(Severity.Success, Messages.Stage_Created_Success);
                this.appMainService.isHideSpinner('createStage');
            }, (err) => {
                this.displayCreateUpdateStage = false;
                const message: string = this.configService.getErrorMessage(err, 'STAGE_CREATE');
                this.configService.openToast(Severity.Error, message);
                this.appMainService.isHideSpinner('createStage');
            });
    }

    updateStage(stageData: Stage): void {
        const hasDuplicateStage: boolean = this.checkDuplicateStage(stageData);

        if (hasDuplicateStage) {
            this.configService.openToast(Severity.Error, Messages.Stage_Already_Exists);
            return;
        }

        stageData.stageId = stageData.id;

        this.appMainService.isShowSpinner('updateStage');

        this.configService.updateStage(stageData)
            .pipe(takeUntil(this.ngUnsubscribe), mergeMap(async () => this.getChannelStages(true, stageData.channelId)))
            .subscribe(() => {
                this.displayCreateUpdateStage = false;
                this.configService.openToast(Severity.Success, Messages.Stage_Updated_Success);
                this.appMainService.isHideSpinner('updateStage');
            }, (err) => {
                this.displayCreateUpdateStage = false;
                const message: string = this.configService.getErrorMessage(err, 'STAGE_UPDATE');
                this.configService.openToast(Severity.Error, message);
                this.appMainService.isHideSpinner('updateStage');
            });
    }

    deleteStage(channelId: number, stageId: number): void {
        this.confirmationService.confirm({
            message: 'Do you want to delete channel\'s Stage?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.appMainService.isShowSpinner('deleteStage');

                this.configService.deleteStage(this.moduleId, channelId, stageId)
                    .pipe(takeUntil(this.ngUnsubscribe), mergeMap(async () => this.getChannelStages(true, channelId)))
                    .subscribe(() => {
                        this.configService.openToast(Severity.Success, Messages.Stage_Deleted_Success);
                        this.appMainService.isHideSpinner('deleteStage');
                    }, (err) => {
                        const message: string = this.configService.getErrorMessage(err, 'STAGE_DELETE');
                        this.configService.openToast(Severity.Error, message);
                        this.appMainService.isHideSpinner('deleteStage');
                    });
            }
        });
    }

    checkDuplicateStage(stageData: Stage): boolean {
        const respectiveChannel: Channel = this.channels.find(channel => channel.id === stageData.channelId);
        const stageList: Stage[] = respectiveChannel?.stageList || [];
        const stageWithDuplicateName: Stage = stageList.find(stage => stage.id !== stageData.id &&
            stage.name.toLowerCase() === stageData.name.toLowerCase());
        return !!stageWithDuplicateName;
    }

    showCreateUpdateStageModal(action: string, channelData: Channel, stageData?: Stage): void {
        if (action === 'update stage'){
            this.isStageEdit = true;
        }

        let stageDataValue: Partial<Stage>

        if (stageData) {
            stageDataValue = stageData;
        } else {
            stageDataValue = {
                name: '',
                isActive: true,
                color: this.defaultColor
            };
        }

        stageDataValue.channelId = channelData.id;
        stageDataValue.moduleId = this.moduleId;

        if (this.moduleId === OpportunityModuleId && action === 'create stage') {
            stageDataValue.probability = 1;
        }

        if(action == 'create stage'){
            this.forcastCategoryEditList = this.forcastCategories.filter(x => x.name != 'Closed Won' && x.name != 'Closed Lost');
        }else{
            if(this.isNullOrUndefinedOrEmptyString(stageData?.forcastCategoryName)){
                this.forcastCategoryEditList = this.forcastCategories.filter(x => x.name != 'Closed Won' && x.name != 'Closed Lost');
            }else{
                this.forcastCategoryEditList = this.forcastCategories.filter((data)=>{
                    return data?.name == stageData?.forcastCategoryName
                })
            }
        }
        stageDataValue.forcastCategory = this.forcastCategoryEditList.find((data)=>{
                return data?.name == stageDataValue?.forcastCategoryName
            });
        this.action = action;
        this.displayCreateUpdateStage = true;
        this.channelStageForm.patchValue(stageDataValue);
    }

    createUpdateChannelStage(stageData: any) {
        const data : Stage = { ...stageData, forcastCategory: stageData.forcastCategory?.id};
        this.action === 'create stage' ? this.createStage(data) : this.updateStage(data);
    }

    dropStage(event) {

        if (!this.isDraggable || !this.dragChannel?.stageList?.length || !this.dragStage) {
            return;
        }

        const prevIndex = this.dragChannel.stageList.findIndex(stage => stage.id === this.dragStage.id);

        const diff = event.previousIndex - prevIndex;
        const currentIndex = event.currentIndex - diff;

        moveItemInArray(this.dragChannel?.stageList, prevIndex, currentIndex);
        let arr = [];
        for (let [i, s] of this.dragChannel?.stageList.entries()) {
            let ii = Number(i);
            let temp = this.dragChannel?.stageList[ii];
            temp.displayOrder = ii + 1;
            s = JSON.parse(JSON.stringify(temp));
            arr.push(s)
        }
        this.dragChannel.stageList = arr;

        const stageData: StageDisplayOrderUpdate = {
            moduleId: this.moduleId,
            channelId: this.dragChannel.id,
            displayOrders: []
        }

        this.dragChannel.stageList.map((stage, index) => {
            stageData.displayOrders.push({
                stageId: stage.id,
                order: index + 1
            })
        })

        this.appMainService.isShowSpinner('updateStageOrder');
        this.configService.updateStageDisplayOrder(stageData)
            .pipe(takeUntil(this.ngUnsubscribe), mergeMap(async () => this.getChannelStages(true, stageData.channelId)))
            .subscribe(() => {
                this.configService.openToast(Severity.Success, Messages.Stage_Updated_Success);
                this.appMainService.isHideSpinner('updateStageOrder');
            }, (err) => {
                const message: string = this.configService.getErrorMessage(err, 'STAGE_UPDATE');
                this.configService.openToast(Severity.Error, message);
                this.appMainService.isHideSpinner('updateStageOrder');
            });

    }

    dragStart(event, channel, stage) {
        this.isDraggable = !stage.systemGenerated;

        if (!this.isDraggable) {
            const message: string = 'System generated stages can not be reordered...';
            this.configService.openToast(Severity.Error, message);
        }

        this.dragStage = stage;
        this.dragChannel = channel;
    }

    getForecastCategory() {
        this.appMainService.isShowSpinner('forcastCategory')
        this.opportunityService.getForecastCategories().subscribe(
          forecastCategory => {
            this.appMainService.isHideSpinner('forcastCategory')
            // this.forcastCategories = forecastCategory.filter(x => x.name != 'Closed Won' && x.name != 'Closed Lost');
            this.forcastCategories = forecastCategory;
          },
          err => {
            this.appMainService.isHideSpinner('forcastCategory')
          })
      }

    cancelCreateUpdateModal(): void {
        this.displayCreateUpdateChannel = false;
        this.cancelChannelAddUpdateModal.emit();
    }

    isNullOrUndefinedOrEmptyString(data: any): boolean {
        if (data == null || data == undefined || data == '') {
            return true;
        } else {
            return false;
        }
    }


    getUserList() {
        this.userService.getUsers(this.app.companyId).then(users => {
            if (users && users.length) {
                this.ownerList = users.filter((obj) => obj.statusId == 1).sort((a, b) => a.name.localeCompare(b.name));
            }
        });
    }

      getSettingsData() {
        this.crmSettingsService.getCrmSettingFieldsList().subscribe({
          next: (response: CrmSettingModel[]) => {
            this.leadOwnerSettings = response?.find(data => data?.moduleId == this.moduleId && data?.code == "StageOwnerSetting");
            this.isEnabledParentChildTemplate=response?.find(data => data?.moduleId == this.moduleId && data?.code == "ParentChildTemplate")?.enabled;
            if(this.isEnabledParentChildTemplate)
                this.crmSettingsService.showEnableDisableColumnSetting=this.isEnabledParentChildTemplate;
            else
            this.crmSettingsService.showEnableDisableColumnSetting=false;
          },
          error: (error) => { }
        });
      }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
